<template>
  <VContainer class="landing-top-wrap">
    <VRow class="relative" align-content="start" justify="center" justify-lg="start" wrap>
      <VCol cols="12" sm="10" lg="5" class="pt-md-6">
        <div class="white--text main-head text-sm-center text-lg-left mb-sm-7 mb-md-11">
          {{ $t('title') }}
        </div>
        <div class="main-description-box mx-sm-16 mx-lg-0 px-sm-0 px-md-5 px-lg-0">
          <div class="display-1 mb-3 mb-md-4">
            {{ $t('reasons') }}:
          </div>
          <div class="mb-3 mb-sm-6 mb-md-6 main-description">
            <div class="d-flex mb-5">
              <svg class="mr-5" width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5179 19.6875H16.7143V0.984375C16.7143 0.440713 16.2826 0 15.75 0H2.25C1.71743 0 1.28571 0.440713 1.28571 0.984375V19.6875H0.482143C0.215879 19.6875 0 19.9079 0 20.1797V21H18V20.1797C18 19.9079 17.7841 19.6875 17.5179 19.6875ZM5.14286 3.11719C5.14286 2.84538 5.35874 2.625 5.625 2.625H7.23214C7.49841 2.625 7.71429 2.84538 7.71429 3.11719V4.75781C7.71429 5.02962 7.49841 5.25 7.23214 5.25H5.625C5.35874 5.25 5.14286 5.02962 5.14286 4.75781V3.11719ZM5.14286 7.05469C5.14286 6.78288 5.35874 6.5625 5.625 6.5625H7.23214C7.49841 6.5625 7.71429 6.78288 7.71429 7.05469V8.69531C7.71429 8.96712 7.49841 9.1875 7.23214 9.1875H5.625C5.35874 9.1875 5.14286 8.96712 5.14286 8.69531V7.05469ZM7.23214 13.125H5.625C5.35874 13.125 5.14286 12.9046 5.14286 12.6328V10.9922C5.14286 10.7204 5.35874 10.5 5.625 10.5H7.23214C7.49841 10.5 7.71429 10.7204 7.71429 10.9922V12.6328C7.71429 12.9046 7.49841 13.125 7.23214 13.125ZM10.2857 19.6875H7.71429V16.2422C7.71429 15.9704 7.93017 15.75 8.19643 15.75H9.80357C10.0698 15.75 10.2857 15.9704 10.2857 16.2422V19.6875ZM12.8571 12.6328C12.8571 12.9046 12.6413 13.125 12.375 13.125H10.7679C10.5016 13.125 10.2857 12.9046 10.2857 12.6328V10.9922C10.2857 10.7204 10.5016 10.5 10.7679 10.5H12.375C12.6413 10.5 12.8571 10.7204 12.8571 10.9922V12.6328ZM12.8571 8.69531C12.8571 8.96712 12.6413 9.1875 12.375 9.1875H10.7679C10.5016 9.1875 10.2857 8.96712 10.2857 8.69531V7.05469C10.2857 6.78288 10.5016 6.5625 10.7679 6.5625H12.375C12.6413 6.5625 12.8571 6.78288 12.8571 7.05469V8.69531ZM12.8571 4.75781C12.8571 5.02962 12.6413 5.25 12.375 5.25H10.7679C10.5016 5.25 10.2857 5.02962 10.2857 4.75781V3.11719C10.2857 2.84538 10.5016 2.625 10.7679 2.625H12.375C12.6413 2.625 12.8571 2.84538 12.8571 3.11719V4.75781Z" fill="white" />
              </svg>
              <div class="main-description__icontent">
                <span class="font-weight-bold">{{ $t('employer') }}:</span>
                {{ $t('employerReason') }}
              </div>
            </div>
            <div class="d-flex mb-6">
              <svg class="mr-5" width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 7.34722V8.625H13.6957V15.6528H7.6087V18.4319L12.4783 20.6681V23H11.2609V21.4986L7.6087 19.8375V23H6.3913V19.8375L2.73913 21.4986V23H1.52174V20.6681L6.3913 18.4319V15.6528H0.304348V8.625H0V7.34722H1.52174V14.375H12.4783V7.34722H14ZM11.6261 13.4167H2.37391L3.37826 0H10.5913L11.6261 13.4167ZM8.52174 8.625H5.47826V9.90278H8.52174V8.625ZM8.52174 6.06944H5.47826V7.34722H8.52174V6.06944ZM8.52174 3.51389H5.47826V4.79167H8.52174V3.51389Z" fill="white" />
              </svg>
              <div class="main-description__icontent">
                <span class="font-weight-bold">{{ $t('applicant') }}:</span>
                {{ $t('applicantReason') }}
              </div>
            </div>
          </div>
          <VRow justify="center" justify-sm="start">
            <VCol cols="11" sm="12" lg="7">
              <div
                class="
                  d-flex
                  flex-column flex-lg-column flex-sm-row align-center align-md-start
                  justify-space-between
                  ml-lg-9"
              >
                <VBtn
                  class="mb-5 mb-sm-0 mb-md-6 mr-sm-4 mr-md-0"
                  color="success"
                  dark
                  x-large
                  :width="($vuetify.breakpoint.lgAndUp || $vuetify.breakpoint.xs) ? '100%' : '49%'"
                  @click="$vuetify.goTo('#register-form')"
                >
                  {{ $t('signUp') }}
                </VBtn>
                <VBtn
                  :to="{
                    name: 'demo',
                    params: { lang: locale }
                  }"
                  outlined
                  x-large
                  dark
                  :width="($vuetify.breakpoint.lgAndUp || $vuetify.breakpoint.xs) ? '100%' : '49%'"
                  class="top-link text-center"
                >
                  {{ $t('testInterview') }}
                </VBtn>
              </div>
            </VCol>
          </VRow>
        </div>
      </VCol>
      <VCol cols="12" lg="7" class="relative front-slider">
        <VSheet class="video">
          <div
            class="arrow left d-none d-sm-block"
            @click="activeSlide = !activeSlide ? 3 : activeSlide - 1"
          />
          <div
            class="arrow right d-none d-sm-block"
            @click="activeSlide++"
          />
          <VCarousel
            v-model="activeSlide"
            class="front-carousel"
            hide-delimiter-background
            :show-arrows="false"
            height="auto"
            light
          >
            <VCarouselItem
              v-for="slide in items"
              :key="slide.key"
              eager
            >
              <VResponsive v-if="$vuetify.breakpoint.smAndUp" :aspect-ratio="674 / 407">
                <div class="slide">
                  <img
                    :src="require(`../../assets/img/landing/top-slider/${slide.svg}`)"
                    :alt="slide.title"
                  >
                  <div class="slide__content">
                    <div class="title">
                      {{ $t(slide.name) }}
                    </div>
                    <p>
                      {{ $t(`${slide.name}Tip`) }}
                    </p>
                  </div>
                </div>
              </VResponsive>
              <div v-else class="slide">
                <div class="img">
                  <img
                    :src="require(`../../assets/img/landing/top-slider/mobile/${slide.svg}`)"
                    :alt="slide.title"
                  >
                </div>
                <div class="slide__content">
                  <div class="title">
                    {{ $t(slide.name) }}
                  </div>
                  <p>
                    {{ $t(`${slide.name}Tip`) }}
                  </p>
                </div>
              </div>
            </VCarouselItem>
          </VCarousel>
        </VSheet>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import useUtm from '@/compositions/useUtm';
import { cabinetUrl } from '../../functions';
import useLocale from '../../compositions/useLocale';

export default {
  name: 'LandingTop',
  setup() {
    const { getUtm } = useUtm();
    const { locale } = useLocale();

    const activeSlide = ref(0);
    const registerLink = cabinetUrl(`registration?${new URLSearchParams(getUtm()).toString()}`);
    const items = [
      {
        key: 0,
        name: 'interviewYourself',
        svg: 'slide1.jpg',
      },
      {
        key: 1,
        name: 'createVacancy',
        svg: 'slide2.jpg',
        width: '31.602%',
      },
      {
        key: 2,
        name: 'inviteCandidates',
        svg: 'slide3.jpg',
        width: '42.136%',
      },
      {
        key: 3,
        name: 'beingInterviewed',
        svg: 'slide4.jpg',
        width: '36.498%',
      },
      {
        key: 4,
        name: 'chooseCandidate',
        svg: 'slide5.jpg',
        width: '31.602%',
      },
    ];

    return {
      activeSlide,
      registerLink,
      items,
      locale,
    };
  },
};
</script>

<style scoped lang="scss">

.main-description {
  line-height: 1.6;

  &__icontent {
    width: calc(100% - 38px);
  }
}

.main-description-box {
  color: white;
}

.main-head {
  font-size: 2.125rem;
  line-height: 1.35;
}

.front-slider {
  padding-bottom: 3rem;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    background: url(../../assets/img/landing/top-slider/slider-bg-mobile.svg) no-repeat left top;
    background-size: contain;
  }
}

.top-link {
  border-color: rgba(255, 255, 255, 0.1);
}

.video {
  background: #F3F3F3;
  box-shadow: 0px 34px 64px rgba(13, 131, 208, 0.13);
  max-width: 450px;
  margin: 0 auto;
  border-radius: 8px;
  left: 86px;
  top: 51px;

  .arrow {
    width: 32px;
    height: 22px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.2;
    transition: opacity 300ms ease;

    &:hover {
      opacity: 1;
    }

    &.left {
      background-image: url(../../assets/img/landing/top-slider/arrow-left.svg);
      right: calc(100% + 21px);
    }

    &.right {
      background-image: url(../../assets/img/landing/top-slider/arrow-right.svg);
      left: calc(100% + 21px);
    }
  }

  .holder {
    overflow: hidden;


    .dots {
      position: absolute;
      left: 50%;
      bottom: 10%;
      transform: translateX(-50%);

      .dot {
        width: 8px;
        height: 8px;
      }
    }

    .slider {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      overflow: hidden;
      transition: all 300ms ease;
    }
  }

  .slide {
    display: flex;
    padding: 0;
    align-items: center;

    img {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      border-radius: 8px;
    }

    &__content {
      width: 45%;
      padding-left: 60px;
      position: relative;

      .title {
        line-height: 1.2em;
        margin-bottom: 10px;
      }

      p {
        line-height: 1.4em;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .main-head,
  .display-2 {
    font-size: 1.1125rem !important;
    line-height: 1.3;
    margin-bottom: 16px;
  }
  .display-1 {
    font-size: 0.875rem !important;
    line-height: 1.3;
  }

  .main-description {
    &__icontent {
      font-size: 0.875rem !important;
      line-height: 124%;
      font-weight: 300;
    }
  }

  .front-slider {
    &::before {
      width: 100vw;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      height: 87.8125vw;
    }
  }

  .video {
    position: relative;
    max-width: initial;
    background: none;
    width: 93.75vw;
    left: 50%;
    transform: translateX(-50%);

    .front-carousel {
    }

    .slide {
      flex-direction: column;
      padding-top: 5vw;

      .img {
        position:relative;
        overflow: hidden;
        border-radius: 8px;
        width: 100%;
        background: #F3F3F3;
      }

      img {
        position: relative;
        //left: -19%;
        display: block;
      }

      &__content {
        width: 100%;
        padding: 9vw 24px 30px;
        color: #fff;
        font-size: 0.875rem;

        .title {
          font-size: 1rem !important;
        }
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-only')} {
  .main-head,
  .display-2 {
    font-size: 1.375rem !important;
    line-height: 1.3;
  }
  .display-1 {
    font-size: 1.1125rem !important;
    line-height: 1.3;
  }
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .main-description-box,
  .top-link {
    color: #fff;
  }
  .reg-btn {
    background: #fff !important;
    color: #2a75e5 !important;
  }
  .front-slider {
    padding: calc(7.8125vw - 12px) 12px;
    margin-bottom: 7.8125vw;

    &::before {
      background-image: url(../../assets/img/landing/top-slider/slider-bg-ipad.svg);
      width: 85.9375vw;
      height: 0;
      padding-top: 66.52%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .video {
    position: relative;
    width: 72.265625vw;
    max-width: initial;
    top: 0;
    left: 1vw;
    margin: 0 auto;
    .slide {
      height: 100%;

      &__content {
        width: 47%;
        padding-top: 0px;
        padding-left: 41px;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .front-slider {
    padding-top: 12px;
    padding-bottom: 12px;
    margin-bottom: 0;

    &::before {
      width: 873px;
      height: 604px;
      left: 0;
      transform: none;
      background-image: url(../../assets/img/landing/top-slider/slider-bg.svg);
    }
  }
  .video {
    max-width: 674px;
    position: absolute;
    width: 48.75vw;
    left: 69px;
    top: 49px;
  }
}
</style>

<!-- eslint-disable max-len -->
<i18n locale="en" lang="yaml">
  title: Huntica is the first automated interview service with a real person
  reasons: The problems it solves
  employer: For the employer
  employerReason: No need to sit through dozens of bad interviews for one good candidate
  applicant: For the applicant
  applicantReason: The opportunity to take an interview anywhere, at any time
  signUp: Sign up
  testInterview: Demo interview
  createVacancy: Create a job
  createVacancyTip: The user-friendly interface helps create jobs where applicants can record video responses.
  inviteCandidates: Invite applicants
  inviteCandidatesTip: Invite applicants by posting a job that anyone can respond to.
  beingInterviewed: The applicant is being interviewed
  beingInterviewedTip: The applicant is interviewed live by a pre-recorded actor. This process is far more comfortable and less stressful than recording responses to text questions.
  chooseCandidate: Select the best applicants
  chooseCandidateTip: Handling applicants is just as easy as moving cards on a bulletin board. Drag and drop to change the applicant's status.
  interviewYourself: Still interviewing applicants in-person?
  interviewYourselfTip: With Huntica, you no longer need to ask the same questions over and over again. We will interview the candidates without you being involved. All you have to do is select the best!
</i18n>

<i18n locale="ru" lang="yaml">
  title: Huntica — это первый сервис виртуальных собеседований с человеческим лицом
  reasons: Какие проблемы она решает
  employer: Для работодателя
  employerReason: не придется отсиживать заведомо провальные интервью
  applicant: Для соискателя
  applicantReason: не нужно никуда ехать, можно пройти собеседование в любое время — не нужно отпрашиваться с текущей работы
  signUp: Зарегистрироваться
  testInterview: Тестовое интервью
  createVacancy: Создайте вакансию
  createVacancyTip: Удобный интерфейс позволяет быстро создавать вакансии, на которые кандидаты будут записывать видео-отклики.
  inviteCandidates: Приглашайте кандидатов
  inviteCandidatesTip: Приглашайте кандидатов из личного кабинета, с помощью расширения для Chrome, или разместите открытую вакансию, на которую сможет откликнуться любой желающий.
  beingInterviewed: Кандидат проходит интервью
  beingInterviewedTip: Кандидат проходит интервью в формате живого общения с заранее записанным актёром. Это комфортнее и привычнее, чем записывать видео с ответами на текстовые вопросы.
  chooseCandidate: Отбирайте лучших кандидатов
  chooseCandidateTip: Работа с кандидатами стала удобнее с канбан-доской. Чтобы поменять статус кандидата, достаточно одного движения мыши!
  interviewYourself: Все еще проводите собеседования сами?
  interviewYourselfTip: С сервисом Huntica вам больше не придется бесконечно задавать одни и те же вопросы. Наши герои проведут собеседования сами, вам останется только отобрать подходящих кандидатов.
</i18n>
<!-- eslint-ensable max-len -->
